@if (parentFormGroup?.controls[controlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
  [ngClass]="{
        'enabled-clear-selection': enableClearSelection &&
                                   parentFormGroup?.controls[controlName].value?.length &&
                                   parentFormGroup?.controls[controlName].status !== 'DISABLED',
      }"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label [class.error]="error" class="label"
        >{{ label }}@if (isRequired) {
        <span>*&nbsp;</span>
        }:
      </mat-label>
    }
    <mat-select
      #select
      (keydown)="$event.preventDefault()"
      (selectionChange)="onSelectionChange($event)"
      [formControlName]="controlName"
      [multiple]="true"
      [compareWith]="compareWithValue"
    [ngClass]="{
      'enabled-clear-selections':
        parentFormGroup?.controls[controlName].status !== 'DISABLED' &&
        enableClearSelection && parentFormGroup?.getRawValue()[controlName]?.length
    }"
      [panelClass]="optionsPanelClassName"
      [placeholder]="placeholder"
      class="select"
      disableOptionCentering
      panelClass="testClass"
      >
      <mat-select-trigger>
        {{ getSelectedCountText() || placeholder }}
      </mat-select-trigger>
      @if (loading) {
        <mat-option class="dropdown-loading" disabled>
          <mat-spinner [diameter]="20" class="dropdown-loader" mode="indeterminate"> </mat-spinner>
        </mat-option>
      } @else {
        <!-- SEARCH SECTION -->
        @if (options?.length && enableSearch) {
          <form [formGroup]="searchForm">
            <div class="filter-section search-section">
              <div class="search">
                <mat-icon svgIcon="search"></mat-icon>
                <input
                  (keydown)="$event.stopPropagation()"
                  formControlName="text"
                  matInput
                  placeholder="Search"
                  />
              </div>
            </div>
          </form>
        }
        @if (filteredOptions?.length || enableSelectAll) {
          <div>
            <!-- SELECT ALL OPTION -->
            @if (enableSelectAll) {
              <mat-option
                [value]="selectAllValue"
                [class.select-all-option]="true"
                (click)="onSelectAllClick($event)"
                >
                <mat-checkbox
                  [checked]="isSelectAllChecked()"
                  [indeterminate]="isSelectAllIndeterminate()"
                  (click)="onSelectAllClick($event); $event.stopPropagation()"
                  [disableRipple]="true"
                  color="primary"
                  >
                  {{ selectAllLabel }}
                </mat-checkbox>
              </mat-option>
            }
            <!-- REGULAR OPTIONS -->
            @for (option of filteredOptions; track option) {
              <mat-option
                [disabled]="option?.disabled"
                [value]="option?.value"
                class="single-select-option"
                >
                {{ option?.label }}
              </mat-option>
            }
          </div>
        } @else {
          <mat-option class="no-data" disabled> No options available </mat-option>
        }
      }
    </mat-select>
    @if (!isDisabled) {
      <mat-icon
        class="suffix-icon"
        matSuffix
        svgIcon="chevron-light"
        />
    }
    @if (shouldShowClearButton()) {
      <mat-icon
        (click)="clearSelection($event)"
        class="clear-selection"
        svgIcon="close"
        matSuffix
        matTooltip="Clear"
        />
    }
    @if (error) {
      <mat-error>{{ error }}</mat-error>
    }
  </mat-form-field>
}
